import { render } from "./ServiceDetails.component.vue?vue&type=template&id=332ac054"
import script from "./ServiceDetails.component.vue?vue&type=script&lang=js"
export * from "./ServiceDetails.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/phoneBook/servicesContent/servicesContentComponents/ServiceDetails.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "332ac054"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('332ac054', __exports__)) {
    console.log('reload')
    api.reload('332ac054', __exports__)
  }
  
  module.hot.accept("./ServiceDetails.component.vue?vue&type=template&id=332ac054", () => {
    console.log('re-render')
    api.rerender('332ac054', render)
  })

}


export default __exports__